import { Box } from "@mui/material";
import React from "react";
import { NavLink } from "react-router-dom";
import paths from "../../../api/paths";
import { ASSETS_PATH } from "../../../utils/constants";

export default function Logo({ handleNavClick }) {
  return (
    <Box
      sx={{
        flexGrow: 1,
        cursor: "pointer",
      }}
      component={NavLink}
      to={paths.homePage}
      onClick={() => handleNavClick("hero")}
    >
      <img
        // src={ASSETS_PATH + "Rubicon.png"}//R+SLOGAN
        src={ASSETS_PATH + "R+SLOGAN.png"}
        // src={ASSETS_PATH + "logo-with-slogan.jpeg"}
        alt="logo"
        className="logo"
        // style={{ width: "12rem" }}
      />
    </Box>
  );
}
